import { cn } from '@/shared/utils/cn';

interface Props {
  className?: string;
}

export function NoFiltersMessage({ className }: Props) {
  return (
    <div className={cn('flex h-full items-center justify-center', className)}>
      <div className="space-y-3 p-6 text-center">
        <p className="text-base text-zinc-500">🛠️ Add filter and update the preview</p>
      </div>
    </div>
  );
}
